export default __webpack_public_path__ + "assets/img/ict-eraseArea.92472839449cec75c78f8722ef38eea3.svg";